<script setup lang="ts">
import UserResetPasswordView from 'src/modules/User/views/UserResetPasswordView/UserResetPasswordView.vue';
import { useQuasar } from 'quasar';
import UserAuthPageDecoration from 'src/shared/components/UserAuthPageDecoration/UserAuthPageDecoration.vue';

const $q = useQuasar();
$q.dark.set(true);
</script>

<template>
  <q-page
    padding
    class="column bg-dark"
  >
    <UserResetPasswordView
      class="column fit items-center justify-center relative"
    />
    <UserAuthPageDecoration />
  </q-page>
</template>
